
import type { PropType, SetupContext } from 'vue'
import { defineComponent, ref } from 'vue'
import { UiConfirm } from '../keen-ui'
import { EpbButton } from '../shared/epb-button'
import ToolingCollapsibleContainer from '../tooling/tooling-collapsible-container.component.vue'
import ToolingEmptyList from '../tooling/tooling-empty-list.component.vue'

export interface QueryRankingSettingsSectionRemoveAllMessages {
  label: string
  title: string
  description: string
  actions: {
    confirm: string
    cancel: string
  }
}

export default defineComponent({
  name: 'QueryRankingSettingsSection',
  components: {
    EpbButton,
    ToolingCollapsibleContainer,
    ToolingEmptyList,
    UiConfirm,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    toolCount: {
      type: Number,
      required: true,
    },
    messages: {
      type: Object as PropType<{ setupRanking: string; emptyList: string }>,
      required: true,
    },
    removeAllMessages: {
      type: Object as PropType<QueryRankingSettingsSectionRemoveAllMessages>,
      required: true,
    },
    disabled: Boolean,
  },
  emits: ['addClick', 'removeAll'],
  setup(props, { emit }: SetupContext) {
    const removeAllConfirmDialog = ref<{ open: () => void }>()

    function onAddClick(): void {
      emit('addClick')
    }

    function openRemoveAllConfirm(): void {
      removeAllConfirmDialog.value?.open()
    }

    function onRemoveAllConfirm(): void {
      emit('removeAll')
    }

    return {
      baseClass: 'query-ranking-settings-section',
      removeAllConfirmDialog,
      onAddClick,
      openRemoveAllConfirm,
      onRemoveAllConfirm,
    }
  },
})
